jQuery(document).ready(function($) {
  jQuery(document).on('click', '.zoom-container', function() {
    jQuery(this).toggleClass('is-zoomed')
    const imgH = jQuery(this).parents('.mfp-content').find('.mfp-img').height()
    const imgW = jQuery(this).parents('.mfp-content').find('.mfp-img').width()
    console.log(imgH, imgW);
    jQuery(this).css({
      height: imgH,
      width: imgW
    })
  })
  jQuery(document).on('mousemove', '.zoom-container', function(e) {
    var relX = (e.pageX - $(this).offset().left)
    var relY = (e.pageY - $(this).offset().top)
    var relHeight = e.currentTarget.clientHeight
    var relWidth = e.currentTarget.clientWidth

    const px = relX / relWidth * 100
    const py = relY / relHeight * 100

    jQuery(this).find('.zoom-wrapper').css({
      backgroundPosition: `${ px }% ${ py }%`
    })
  })
});